import React, {Component} from 'react';
import {Cancel, ArrowDropDown, ThreeSixty} from '@material-ui/icons';
import {T} from 'Actions/translate';
import util from 'Utils/commonUtil';

class Dropdown extends Component {
    isOnComposition = false;
    state = {
        emptyValidation: true,
        focus: false,
        firstAssignValue: true,
        open: false,
    };

    componentWillReceiveProps(nextProps) {
        if (this.input) {
            if (
                this.state.firstAssignValue &&
                util.isString(nextProps.defalutValue)
            ) {
                this.input.value = nextProps.defalutValue;
                this.props.inputValid(this.props.title, nextProps.defalutValue);

                this.setState({
                    firstAssignValue: false,
                });
            } else if (
                nextProps.value !== this.input.value &&
                util.isString(nextProps.value)
            ) {
                this.input.value = nextProps.value;
            }
        }
    }

    clearInput = () => {
        this.input.value = '';
        if (this.props.currentKey !== 'undefined' && this.props.currentKey) {
            this.props.inputValid(this.props.title, '', this.props.currentKey);
        } else {
            this.props.inputValid(this.props.title, '');
        }
    };

    foucusInput = () => {
        this.setState({
            focus: true,
        });

        if (this.props.focusInput) {
            this.props.focusInput();
            this.setState({
                open: true,
            });
        }
    };

    blurAction = () => {
        setTimeout(() => {
            this.setState({
                focus: false,
                open: false,
            });
        }, 260);
    };

    inputValid = (title) => (event) => {
        let empty = true;
        if (!event.target.value && this.props.required) {
            empty = false;
        }
        this.setState({
            emptyValidation: empty,
            open: true,
        });
        this.props.inputValid(title, event.target.value);
    };
    handleComposition = (evt) => {
        if (evt.type === 'compositionend') {
            this.isOnComposition = false;

            // 谷歌浏览器：compositionstart onChange compositionend
            // 火狐浏览器：compositionstart compositionend onChange
            if (navigator.userAgent.indexOf('Chrome') > -1) {
                this.inputValid(evt);
            }
        }

        this.isOnComposition = true;
    };

    chooseSearchData = (item) => {
        if (this.props.currentKey !== 'undefined' && this.props.currentKey) {
            this.props.inputValid(
                this.props.name,
                item,
                this.props.currentKey,
                this.props,
            );
        } else {
            this.props.inputValid(this.props.title, item, true);
        }
        this.input.value = item.fullName;
        this.setState({
            open: false,
        });
    };

    render() {
        const {title, placeholder, type, list, required, value, testid} =
            this.props;
        const {emptyValidation, focus, open} = this.state;

        let isNeedValue = false;
        if (this.props.currentKey !== 'undefined' && this.props.currentKey) {
            isNeedValue = true;
        }

        return (
            <div
                className={
                    emptyValidation ? 'select-input' : 'select-input empty'
                }>
                {required ? <span className="form-required">*</span> : null}
                <label className="input-title">{T(title)}</label>
                <input
                    className="input-content"
                    onChange={this.inputValid(title)}
                    onCompositionStart={this.handleComposition}
                    onCompositionUpdate={this.handleComposition}
                    onCompositionEnd={this.handleComposition}
                    placeholder={
                        emptyValidation ? T(placeholder) : T('input_required')
                    }
                    type={type || 'text'}
                    ref={(input) => (this.input = input)}
                    onBlur={this.blurAction}
                    onFocus={this.foucusInput}
                    readOnly
                />

                {util.getPropertyExistsAndIsTrue(
                    this.props.showArrowDropDown,
                ) ? (
                    <ArrowDropDown
                        onClick={this.foucusInput}
                        className="cancel-button"
                        testid={testid ? `${testid}-icon` : ''}
                    />
                ) : null}
                {open && list && list.length > 0 ? (
                    <div id="search-list" className="search-list">
                        {list.map((item) => {
                            return (
                                <div
                                    key={item.id}
                                    testid={testid ? testid : ''}
                                    className="search-option"
                                    onClick={this.chooseSearchData.bind(
                                        this,
                                        item,
                                    )}>
                                    {item.fullName}
                                </div>
                            );
                        })}
                    </div>
                ) : null}
            </div>
        );
    }
}

export default Dropdown;
